import React from "react";
import classNames from "classnames";
import { CompountComponentsProps, DropdownOptionProps, TDropdownContext } from "./types";

import "./styles.scss";

const DropdownContext = React.createContext<TDropdownContext>(null);

export const Dropdown = ({ children, dataQa, className, ...rest }: CompountComponentsProps) => {
  const ref = React.useRef(null);
  const [open, setIsOpen] = React.useState(false);

  const classes = classNames("dropdown", {
    "dropdown--active": open,
    [className]: className,
  });

  const tooglePanel = () => setIsOpen((prevState) => !prevState);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        tooglePanel();
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <DropdownContext.Provider value={{ open, tooglePanel }}>
      <div
        {...rest}
        data-qa={dataQa}
        className={classes}
        ref={ref}>
        {children}
      </div>
    </DropdownContext.Provider>
  );
};

Dropdown.Button = function DropdownButton({ children, dataQa, ...rest }: CompountComponentsProps) {
  const Context = React.useContext(DropdownContext);

  const onClickHandler = () => {
    Context?.tooglePanel();
  };

  return (
    <div
      onClick={onClickHandler}
      data-qa={dataQa}
      {...rest}>
      {children}
    </div>
  );
};

Dropdown.Panel = function DropdownPanel({
  children,
  dataQa,
  className,
  ...rest
}: CompountComponentsProps) {
  const Context = React.useContext(DropdownContext);

  const classes = classNames("panel", {
    "panel--visible": Context?.open,
    [className]: className,
  });

  return (
    <div
      className={classes}
      data-qa={dataQa}
      {...rest}>
      {children}
    </div>
  );
};

Dropdown.Option = function DropdownOption<T extends React.ElementType = "div">({
  as,
  children,
  dataQa,
  ...rest
}: DropdownOptionProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof DropdownOptionProps<T>>) {
  const Context = React.useContext(DropdownContext);
  const Component = as || "div";

  return (
    <Component
      data-qa={dataQa}
      onClick={Context.tooglePanel}
      {...rest}>
      {children}
    </Component>
  );
};
